import React, { useContext, useState, useEffect } from "react";
import { fetchTransaction, fetchUsers, updateTransaction } from "../api/api";
import { UserContext } from "../context/UserContext";
import HeaderQC from "./HeaderQC";

const EditTransaction = ({ transactionId }) => {
  const [transaction, setTransaction] = useState(null);
  const { user } = useContext(UserContext);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(true);
  const [remark, setRemark] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchTransaction(transactionId);
      if (data) setTransaction(data);
      if (data) setFormData(data);
      else console.error("No transaction found");
      setLoading(false);
    };
    fetchData();

    const fetchRole = async () => {
      console.log(user);
      if (!user) return;
      const sus = await fetchUsers(user);
      setUserRole(sus);
    };

    fetchRole();
  }, [transactionId, user]);
  console.log(transaction);
  console.log(userRole);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [fieldName]: reader.result, // Stores base64-encoded image
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    window.location.href = "/login";
  };

  const handleSave = async () => {
    if (formData.remark != null) {
      const updatedData = {
        ...formData,
        updated_date: new Date().toISOString().split("T")[0], // Updating date
      };
      console.log(updatedData);
      try {
        const result = await updateTransaction(
          updatedData.transaction_id, // transaction_id
          user, // member_email_id
          updatedData
        );

        console.log("Update Result:", result);
        alert("Transaction updated successfully!");
      } catch (error) {
        console.error("Update Failed:", error);
        alert("Error: Trnasaction cannot be updated");
      }

      sessionStorage.setItem("refreshOnBack", "true");
      window.history.back();
    } else {
      setRemark(true);
    }
  };

  const viewDocument = (field) => {
    const base64Data = formData[field];
    if (base64Data) {
      const newWindow = window.open();
      newWindow.document.write(`<img src="${base64Data}" />`);
    } else {
      alert("No document available");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!transaction) {
    return (
      <div className="min-h-screen d-flex align-items-center justify-content-center">
        <div className="card border-0 shadow-sm rounded-4 text-center p-5">
          <i className="bi bi-exclamation-circle text-danger display-1 mb-3"></i>
          <h3>Transaction Not Found</h3>
          <p className="text-muted">
            The requested transaction could not be found.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* TOP BAR */}
      <HeaderQC />

      {/* TRANSACTION EDIT FORM */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-white border-0 py-2">
                <h4 className="mb-1" style={{ color: "#1DA5B1" }}>
                  Edit Transaction
                </h4>
                <p className="text-muted mb-0">
                  Transaction ID: {transactionId}
                </p>
              </div>

              <div className="card-body py-2">
                <form>
                  {/* Basic Information */}
                  <h6
                    className="text-uppercase mt-4 mb-3"
                    style={{ color: "#1DA5B1" }}
                  >
                    Basic Information
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Transaction ID</label>
                      <input
                        type="text"
                        value={formData.transaction_id || ""}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Project ID</label>
                      <input
                        type="text"
                        name="project_id"
                        value={formData.project_id || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Actor ID</label>
                      <input
                        type="text"
                        name="actorId"
                        value={formData.actor_id || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Parent Node</label>
                      <input
                        type="text"
                        name="parent_node"
                        value={formData.parent_node || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Level</label>
                      <input
                        type="text"
                        name="level"
                        value={formData.level || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Process Type</label>
                      <input
                        type="text"
                        name="process_type"
                        value={formData.process_type || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>

                  {/* Transaction Details */}
                  <h6
                    className="text-uppercase mt-4 mb-3"
                    style={{ color: "#1DA5B1" }}
                  >
                    Transaction Details
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Entry Date</label>
                      <input
                        type="text"
                        name="entry_date"
                        value={formData.entry_date || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Transaction Date</label>
                      <input
                        type="text"
                        name="transaction_date"
                        value={formData.transaction_date || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Geographical Coordinates
                      </label>
                      <input
                        type="text"
                        name="geographical_coordinates"
                        value={formData.geographical_coordinates || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Crop</label>
                      <input
                        type="text"
                        name="crop"
                        value={formData.crop || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Measuring Unit</label>
                      <input
                        type="text"
                        name="measuring_unit"
                        value={formData.measuring_unit || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Number of Units</label>
                      <input
                        type="number"
                        name="no_of_units"
                        value={formData.no_of_units || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Quantity</label>
                      <input
                        type="number"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Price</label>
                      <input
                        type="number"
                        name="price_per_unit"
                        value={formData.price_per_unit || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Total Amount</label>
                      <input
                        type="number"
                        name="totalAmount"
                        value={
                          formData.quantity * formData.price_per_unit 
                        }
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-8">
                      <label className="form-label"> Comment </label>
                      <input
                        type="text"
                        name="comment"
                        value={formData.comment || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    {formData.problem_reported === true && (
                      <div className="col-md-4">
                        <label className="form-label"> Problem Comment </label>
                        <input
                          type="text"
                          name="problem_comment"
                          value={formData.problem_comment || ""}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                    )}

                    <div className="col-md-4">
                      <label className="form-label"> Updated date </label>
                      <input
                        type="text"
                        name="updated_date"
                        value={formData.updated_date || "No updates"}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>

                  {/* Payment */}
                  <h6
                    className="text-uppercase mt-4 mb-3"
                    style={{ color: "#1DA5B1" }}
                  >
                    Payment & Documents
                  </h6>
                  <div className="col-md-6">
                    <label className="form-label">Payment Document</label>
                    <div className="input-group">
                      <input
                        type="text"
                        name="payment"
                        value={formData.payment || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => viewDocument("payment")}
                      >
                        📄 View
                      </button>
                    </div>
                    <input
                      type="file"
                      className="form-control mt-2"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "payment")}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Transaction Document</label>
                    <div className="input-group">
                      <input
                        type="text"
                        name="transaction_document"
                        value={formData.transaction_document || ""}
                        onChange={handleChange}
                        className="form-control"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => viewDocument("transaction_document")}
                      >
                        📄 View
                      </button>
                    </div>
                    <input
                      type="file"
                      className="form-control mt-2"
                      accept="image/*"
                      onChange={(e) =>
                        handleFileChange(e, "transaction_document")
                      }
                    />
                  </div>

                  <h6
                    className="text-uppercase mt-4 mb-3"
                    style={{ color: "#1DA5B1" }}
                  >
                    Remarks
                  </h6>

                  {userRole.team_id === "C" && (
                    <div className="col-md-4">
                      <p>
                        <strong>Team A Remark:</strong>{" "}
                        {transaction.team_a_remark || "No remark"}
                      </p>
                      <p>
                        <strong>Team B Remark:</strong>{" "}
                        {transaction.team_b_remark || "No remarks"}
                      </p>
                      <p>
                        <strong>Team D Remark:</strong>{" "}
                        {transaction.team_d_remark || "Not approved yet"}
                      </p>
                    </div>
                  )}

                  {userRole.team_id === "B" && (
                    <div className="col-md-4">
                      <p>
                        <strong>Team A Remark:</strong>{" "}
                        {transaction.team_a_remark || "No remark"}
                      </p>

                    </div>
                  )}

                  <div className="col-md-4">
                    <label className="form-label">
                      QC Team {userRole.team_id} Remark
                    </label>
                    <input
                      type="text"
                      name="remark"
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                  {remark && (
                    <p
                      style={{
                        color: "red",
                        marginTop: "4px",
                      }}
                    >
                      ❗ Enter remark
                    </p>
                  )}

                  {/* Save Button */}
                  <div className="d-flex gap-2 mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        sessionStorage.setItem("refreshOnBack", "true");
                        window.history.back();
                      }}
                    >
                      Back
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary w-75"
                      onClick={handleSave}
                    >
                      Approve
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTransaction;
